import { LayoutGrid } from 'lucide-react';
import type { AppIdea } from '@ah/appideas/shared';

export type { AppIdea } from '@ah/appideas/shared';

export function appIdeaCardTitle(_item: AppIdea): string {
  return 'If we build this app, would you use it?';
}

export function AppIdeaCard({ item }: { item: AppIdea }): JSX.Element {
  return (
    <div className="bg-card rounded-2xl border border-border shadow-sm overflow-hidden">
      <div className="w-full aspect-video bg-primary/10 flex items-center justify-center">
        <div className="w-20 h-20 rounded-2xl bg-primary/15 flex items-center justify-center shadow-sm">
          <LayoutGrid size={36} className="text-primary/80" strokeWidth={1.8} />
        </div>
      </div>

      <div className="p-6 space-y-4">
        <div>
          <p className="font-bold text-[22px] leading-tight text-foreground">
            {item.name}
          </p>
          <p className="text-[14px] text-muted-foreground mt-1 leading-snug">
            {item.tagline}
          </p>
        </div>

        <p className="text-[15px] text-foreground/85 leading-relaxed">
          {item.description}
        </p>

        <p className="text-[12px] text-muted-foreground italic">
          If enough members want this, we'll build it.
        </p>
      </div>
    </div>
  );
}
